import { useEffect, useRef, useState } from "react";

export function useScrollFadeIn(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, isVisible };
}

/** Returns className string for fade-in-on-scroll with optional delay (ms). */
export function fadeCls(isVisible: boolean, delay = 0) {
  return `transition-all duration-700 ${
    isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
  }`;
}

/** Returns style object for transition delay. */
export function fadeStyle(delay: number) {
  return delay ? { transitionDelay: `${delay}ms` } : undefined;
}
